import { BrButton, BrTab } from '@govbr-ds/react-components';
import { useEffect, useId, useState } from 'react';
import { Col, Row } from 'react-dsgov';
import style from './anmNotificacaoContainer.module.scss';
import { IErrosValidacaoDeclaracao } from '../../interfaces/IErroValidacaoDeclaracao';

interface INotificacaoProps {
  title: string;
  tabNContent: { tabName: string; tabContent: string[] }[];
  showContainer: boolean;
  setErrosValidacao: React.Dispatch<React.SetStateAction<IErrosValidacaoDeclaracao | undefined>>;
}

const AnmNotificacaoContainer = ({ title, tabNContent, showContainer, setErrosValidacao }: INotificacaoProps) => {
  const [isOpen, setIsOpen] = useState(showContainer);
  const [activeTab, setActiveTab] = useState(0);
  const componentId = useId();
  const prefixId = `anm-notificacao-${componentId}`;

  const hideNotification = () => {
    setIsOpen(false);
    setErrosValidacao({ tabNContent: tabNContent, showContainer: false });
    setActiveTab(0);
  };

  useEffect(() => {
    if (showContainer) {
      setIsOpen(true);
      setActiveTab(0);
    } else {
      setIsOpen(false);
    }
  }, [showContainer]);

  return (
    <>
      {tabNContent && tabNContent.length !== 0 && (
        <div className={style.alertButtonContainer}>
          <BrButton
            onClick={() => setIsOpen(!isOpen)}
            type='button'
            aria-label='Notificações'
            title='Existem pendências de preenchimento'
            data-testid={`${prefixId}-button`}
          >
            <i className={`fas fa-bell ${style.bellIcon}`}></i>
          </BrButton>
          <i className={`fa fa-times-circle ${style.timesIcon}`}></i>
        </div>
      )}
      {isOpen && tabNContent && tabNContent.length !== 0 && (
        <div className={style.br_notification}>
          <div className={style.notification_header}>
            <Row>
              <Col size={10} className={style.titleContainer}>
                <span className={style.title}>{title}</span>
                <br />
              </Col>
              <Col size={2} className={style.textRight}>
                <BrButton
                  className={style.closeButton}
                  type='button'
                  aria-label='Fechar'
                  onClick={hideNotification}
                  title='Fechar'
                  data-testid={`${prefixId}-closeBtn`}
                >
                  <i className='fas fa-times' aria-hidden='true'></i>
                </BrButton>
              </Col>
            </Row>
          </div>
          <div className={style.notification_body}>
            <BrTab onChange={setActiveTab} items={tabNContent.map((tab) => tab.tabName)} activeIndex={activeTab}>
              <div className={style.tab_content}>
                {tabNContent.map((tab, index) => (
                  <div
                    className={`tab-panel ${activeTab === index ? 'active' : ''}`}
                    id={`notification-panel-${tab.tabName}`}
                    key={index}
                  >
                    {tab.tabContent.map((message, msgIndex) => (
                      <div className={style.messageContainer} key={msgIndex}>
                        <button className='br-item' type='button' role='contentInfo' key={msgIndex}>
                          <span className='br-tag status small warning'></span>
                          <span className={style.messageText}>{message}</span>
                        </button>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </BrTab>
          </div>
        </div>
      )}
    </>
  );
};

export default AnmNotificacaoContainer;
